var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.8 49.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.38,0H17.12A6.41,6.41,0,0,0,10.7,6.42V10.7H6.42A6.41,6.41,0,0,0,0,17.12V42.8a6.42,6.42,0,0,0,6.42,6.42H25.68A6.43,6.43,0,0,0,32.1,42.8V38.52h4.28A6.43,6.43,0,0,0,42.8,32.1V6.42A6.42,6.42,0,0,0,36.38,0ZM27.82,42.8a2.14,2.14,0,0,1-2.14,2.14H6.42A2.14,2.14,0,0,1,4.28,42.8V17.12A2.14,2.14,0,0,1,6.42,15H25.68a2.14,2.14,0,0,1,2.14,2.14Zm10.7-10.7a2.14,2.14,0,0,1-2.14,2.14H32.1V17.12a6.42,6.42,0,0,0-6.42-6.42H15V6.42a2.14,2.14,0,0,1,2.14-2.14H36.38a2.14,2.14,0,0,1,2.14,2.14Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.91edacda.svg";
export { ForwardRef as ReactComponent };